import Layout from '@/components/feature/Layout';

export default function LecturacionPage() {
  return (
    <Layout>
      <div className="bg-primary-900 py-16 md:py-24">
        <div className="w-full px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto text-center">
          <span className="inline-block text-xs font-semibold tracking-widest uppercase text-accent-400 mb-3">
            Servicio
          </span>
          <h1 className="font-heading font-bold text-3xl md:text-5xl text-white mb-4">
            Lecturación de Medidores
          </h1>
          <p className="text-white/70 text-sm md:text-base max-w-2xl mx-auto">
            Conoce el proceso de lectura mensual de medidores y cómo reportar tu lectura.
          </p>
        </div>
      </div>

      <div className="w-full px-4 sm:px-6 lg:px-8 py-12 md:py-20">
        <div className="max-w-4xl mx-auto">
          {/* Info cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-12">
            <div className="p-5 rounded-xl bg-background-100 border border-background-200/70">
              <div className="w-10 h-10 rounded-lg bg-primary-50 flex items-center justify-center mb-3">
                <i className="ri-calendar-check-line text-primary-600 w-5 h-5 flex items-center justify-center"></i>
              </div>
              <h3 className="font-heading font-semibold text-foreground-950 mb-1">Lectura Mensual</h3>
              <p className="text-sm text-foreground-600">Nuestro personal visita cada domicilio una vez al mes para registrar el consumo del medidor.</p>
            </div>
            <div className="p-5 rounded-xl bg-background-100 border border-background-200/70">
              <div className="w-10 h-10 rounded-lg bg-accent-50 flex items-center justify-center mb-3">
                <i className="ri-file-list-3-line text-accent-600 w-5 h-5 flex items-center justify-center"></i>
              </div>
              <h3 className="font-heading font-semibold text-foreground-950 mb-1">Recibo de Agua</h3>
              <p className="text-sm text-foreground-600">Una vez procesada la lectura, recibirás tu recibo con el consumo y monto a pagar.</p>
            </div>
            <div className="p-5 rounded-xl bg-background-100 border border-background-200/70">
              <div className="w-10 h-10 rounded-lg bg-secondary-50 flex items-center justify-center mb-3">
                <i className="ri-camera-line text-secondary-600 w-5 h-5 flex items-center justify-center"></i>
              </div>
              <h3 className="font-heading font-semibold text-foreground-950 mb-1">Reportar Lectura</h3>
              <p className="text-sm text-foreground-600">Si no pudimos leer tu medidor, podés reportar tu lectura vos mismo.</p>
            </div>
          </div>

          {/* Main CTA: Reportar lectura en línea */}
          <div className="p-8 md:p-10 rounded-xl bg-background-50 border border-background-200/70 text-center mb-6">
            <div className="w-16 h-16 rounded-2xl bg-primary-50 flex items-center justify-center mx-auto mb-6">
              <i className="ri-computer-line text-primary-600 text-2xl w-8 h-8 flex items-center justify-center"></i>
            </div>

            <h2 className="font-heading font-semibold text-xl text-foreground-950 mb-3">
              Reportar mi lectura en línea
            </h2>
            <p className="text-sm text-foreground-600 mb-8 max-w-md mx-auto leading-relaxed">
              Ingresa a tu portal de usuario para reportar la lectura de tu medidor de forma rápida. También podés consultar tu historial de consumos.
            </p>

            <a
              href="https://codesajancuenta.fluxbostudio.com"
              className="inline-flex items-center gap-3 px-8 py-4 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-xl transition-all duration-300 hover:-translate-y-0.5 text-base"
            >
              <i className="ri-external-link-line w-5 h-5 flex items-center justify-center"></i>
              Reportar mi lectura en línea
            </a>
          </div>

          {/* WhatsApp alternative */}
          <div className="text-center">
            <p className="text-sm text-foreground-500 mb-3">
              ¿Preferís enviar la foto de tu medidor por WhatsApp?
            </p>
            <a
              href="https://wa.me/59173455233?text=Hola%20CODESAJAN,%20env%C3%ADo%20la%20lectura%20de%20mi%20medidor"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-6 py-3 bg-green-500 hover:bg-green-600 text-white font-medium rounded-lg transition-colors text-sm"
            >
              <i className="ri-whatsapp-line w-4 h-4 flex items-center justify-center"></i>
              Enviar por WhatsApp
            </a>
            <p className="text-xs text-foreground-400 mt-3">
              Sacale una foto clara a tu medidor y envianosla.
            </p>
          </div>
        </div>
      </div>
    </Layout>
  );
}